import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import dayjs from "dayjs";
import { loadComptes } from "../../../store/actions/compteAction";
import { loadEcritures } from "../../../store/actions/ecritureAction";
import { loadReglements } from "../../../store/actions/reglementAction";

import FormGrandLivre from "../../../components/FormGrandLivre";

class GrandLivre extends Component {
  componentDidMount() {
    this.props.loadComptes();
    this.props.loadEcritures();
    this.props.loadReglements();
  }

  render() {
    const { comptes, ecritures, report, reglements, grandLivre, annee } = this.props;

    return (
      <Spin
        size="large"
        tip="Chargement en cours..."
        spinning={!comptes || !ecritures || !reglements}
      >
        {comptes && ecritures && (
          <FormGrandLivre
            comptes={comptes}
            ecritures={
              ecritures &&
              ecritures.sort(
                (a, b) =>
                  dayjs(a.ecriture_date_ecriture, "DD/MM/YYYY").unix() -
                  dayjs(b.ecriture_date_ecriture, "DD/MM/YYYY").unix()
              )
            }
            report={report}
            reglements={reglements}
            grandLivre={grandLivre}
            annee={annee}
          />
        )}
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadComptes: () => dispatch(loadComptes()),
    loadEcritures: () => dispatch(loadEcritures()),
    loadReglements: () => dispatch(loadReglements()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    comptes: state.comptes,
    ecritures: state.ecritures.data,
    report: state.ecritures.report,
    reglements: state.reglements.data,
    annee: state.exercice.annee,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GrandLivre);
